import React from 'react';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import ChatContainer from '../../components/Chat/Chat';

// URL: /chat
const Chat = () => (
  <CoachPageLayout>
    <ChatContainer />
  </CoachPageLayout>
);

export default Chat;
